import React from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Lock, ArrowRight } from "lucide-react";

/**
 * PaywallNotice - Redirects to /upgrade page
 * Used throughout the app for PRO feature gates
 */
const PaywallNotice = ({ title, description, testIdPrefix = "paywall" }) => {
  const navigate = useNavigate();
  
  return (
    <Card
      className="border-2 border-purple-200 bg-gradient-to-r from-purple-50 to-indigo-50 cursor-pointer hover:shadow-lg transition-shadow"
      data-testid={`${testIdPrefix}-card`}
      onClick={() => navigate('/upgrade')}
    >
      <CardContent className="p-4 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-gradient-to-br from-purple-500 to-indigo-500 rounded-xl flex items-center justify-center flex-shrink-0">
            <Lock className="w-5 h-5 text-white" />
          </div>
          <div className="space-y-0.5">
            <p
              className="text-sm font-semibold text-purple-900"
              data-testid={`${testIdPrefix}-title`}
            >
              {title || "PRO Feature"}
            </p>
            <p
              className="text-xs text-purple-700"
              data-testid={`${testIdPrefix}-description`}
            >
              {description || "Upgrade to CLARIAS PRO to unlock this feature"}
            </p>
          </div>
        </div>
        <Button
          size="sm"
          className="bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 text-white font-semibold"
          data-testid={`${testIdPrefix}-upgrade-button`}
        >
          Upgrade to PRO
          <ArrowRight className="w-4 h-4 ml-1" />
        </Button>
      </CardContent>
    </Card>
  );
};

export default PaywallNotice;
